import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import CancelModal from "../../../../shared/components/CancelModal";
import { WarningProductModal } from "../../../../configs/warningProductModal";
import { ExtraFee } from "../../../../data/entities";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";

interface TitleProps {
    title: string;
    data?: ExtraFee;
    setValidated: (validate: boolean) => void;
    onSubmit: Function;
    onDataChange?: () => void;
    hasUnsavedChanges?: boolean;
    onCancelClick?: () => void;
    isLoading?: boolean;
}

const Title = ({ 
    title, 
    setValidated, 
    data, 
    onSubmit,
    onDataChange,
    hasUnsavedChanges,
    onCancelClick,
    isLoading = false,
}: TitleProps) => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = [ROLE.MANAGER, ROLE.LOGISTIC_STAFF].includes(role);

    const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
    
    const handleCancel = () => {
        if (onDataChange) {
            onDataChange();
        }
        
        if (onCancelClick && hasUnsavedChanges) {
            onCancelClick();
        } else {
            setIsOpenCancelModal(true);
        }
    };
    
    const titleActions: TitleAction[] = [
        {
            title: "Huỷ bỏ",
            onClick: () => handleCancel(),
        },
        {
            title: "Lưu chi phí",
            variant: "contained",
            isLoading,
            onClick: () => {
                if (isLoading) return;
                setValidated(true);
                onSubmit();
            },
        },
    ];

    const getTitleActions = () => {
        return canEdit ? titleActions : [];
    };

    return (
        <>
            <TitleRow title={title} actions={getTitleActions()} />
            {isOpenCancelModal && (
                <CancelModal
                    open={isOpenCancelModal}
                    title={WarningProductModal.title}
                    contentText={WarningProductModal.context}
                    handleConfirm={() => navigate("/extraFees/")}
                    handleClose={() => setIsOpenCancelModal(false)}
                />
            )}
        </>
    );
};

export default Title;
